import { render, staticRenderFns } from "./SettingButton.vue?vue&type=template&id=2e1afc39&scoped=true"
import script from "./SettingButton.vue?vue&type=script&lang=js"
export * from "./SettingButton.vue?vue&type=script&lang=js"
import style0 from "./SettingButton.vue?vue&type=style&index=0&id=2e1afc39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1afc39",
  null
  
)

export default component.exports